import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useStripeIntegrationCreateAccountMutation(
	shop: ShopDto,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shop.id);

	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/integrations/stripe/account",
	);

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async () => {
			const result = await mutation.mutateAsync({
				params: { path: { shopId: shop.id } },
			});
			window.location.replace(
				(result as { integrations: { stripe: { url: string } } }).integrations
					.stripe.url,
			);
		},
	});
}
